import { DeviceCheckRedirect } from '@/features/device-check';
import { Privacy, Terms } from '@/features/legal';
import { InstagramCallback } from '@/features/oauth';

export const commonRoutes = [
  { path: '/privacy', element: <Privacy /> },
  { path: '/terms', element: <Terms /> },
  { path: '/oauth/instagram/callback', element: <InstagramCallback /> },
  { path: '/t/:slug', element: <DeviceCheckRedirect /> },
];
